async function isProductInCartAsTBYB(productId) {
    const cart = await fetch('/cart.js').then(response => response.json());

    return cart.items.some(item =>
        item.product_id == productId && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.name.includes('Try')
    );
}

document.addEventListener("octane.quiz.completed", async function (event) {
    if(!location.href.includes('skincare-concern-quiz')) return
    const hasPassedTryLink = await window.trynow.hasPassedTryLink()
    if(!hasPassedTryLink) return
    const tryNowLimitMet = await window.trynow.cart.isTryNowCartLimitMet()
    if(tryNowLimitMet) return
    const productResults = event.detail.product_blocks
    const addToCartButtons = document.querySelectorAll('#octane-quiz-wrapper button')
    const calculateVisibility = window.trynow.product.calculateProductVisibilityFromTags;

    addToCartButtons.forEach(async (button, index) => {
        const product = productResults[1] && productResults[1][index];

        const productTags = product.tags.map(tag => tag.toLowerCase());
        const isVisible = await calculateVisibility(productTags);
        if(!isVisible) return

        if(await isProductInCartAsTBYB(product.id)) return

        const clonedButton = button.cloneNode(true)
        clonedButton.textContent = "TRY BEFORE YOU BUY"
        clonedButton.id = "trynow-quiz-cta-button-" + index
        clonedButton.classList.add('trynow-quiz-cta-button')
        clonedButton.style.justifyContent = 'center'
        let variantId;
        if (!product) {
            variantId = null;
        } else if (!product.variants) {
            variantId = product.id;
        } else if (product.variants.length === 1) {
            variantId = product.variants[0].id;
        } else {
            variantId = product.variants.map(variant => variant.id);
        }
        clonedButton.dataset.variantId = JSON.stringify(variantId);
        
        clonedButton.addEventListener('click', async (event) => {
            const btn = event.target;
            btn.disabled = true;
            btn.textContent = "Adding...";

            let sellingPlanId = (await window.trynow.getSellingPlanId()).split('/').pop()
            let variant = JSON.parse(event.target.dataset.variantId);

            if (Array.isArray(variant)) {
                const variantSelect = document.querySelector('select[aria-label="Variant selector"]');
                if (variantSelect) {
                    const selectedIndex = parseInt(variantSelect.value, 10);
                    variant = variant[selectedIndex];
                }
            }

            if(variant == null){
                let variantsToAdd = []
                const buttons = document.querySelectorAll('.trynow-quiz-cta-button')
                buttons.forEach(button => {
                    const variantsInButton = JSON.parse(button.dataset.variantId)
                    if(Array.isArray(variantsInButton)){
                        const selectedVariant = document.querySelector('select[aria-label="Variant selector"]');
                        if(selectedVariant){
                            const selectedVariantIndex = parseInt(selectedVariant.value, 10)
                            variantsToAdd.push(variantsInButton[selectedVariantIndex])
                        }
                    } else if (variantsInButton != null){
                        variantsToAdd.push(variantsInButton)
                    }
                })
                for (const variantId of variantsToAdd) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: variantId,
                            quantity: 1,
                            selling_plan: sellingPlanId
                        })
                    }).catch(err => console.error(err));
                }
                console.log('Products added to cart successfully')
                if(window.trynow) {
                    window.trynow.addToCartClicked()
                }
            } else {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variant,
                        quantity: 1,
                        selling_plan: sellingPlanId
                    })
                }).then(response => {
                    console.log('Product added to cart successfully', response)
                    if(window.trynow) {
                        window.trynow.addToCartClicked()
                    }
                }).catch(error => {
                    console.error('Fetch error:', error);
                });
            }

            btn.textContent = "View Cart";
            btn.disabled = false;

            btn.addEventListener('click', () => {
                window.location.href = "/cart";
            }, { once: true });
        })
        
        button.parentNode.style.display = 'none'
        button.closest('[data-element="oct-quiz-resultitem"]').style.justifyContent = 'normal'
        button.parentNode.insertAdjacentElement('afterend', clonedButton);
    })
})